module.exports = __webpack_public_path__ + "img/04.59c42cdb.png";